import { CARTSTATES, THEME } from 'Assets/js/lib/constants'
import { addItemById } from 'Assets/js/lib/cart'

const closeQuickShop = (id) => {
  const target = document.getElementById(id)
  target.setAttribute('aria-expanded', 'false')
  setTimeout(() => {
    target.remove()
  }, 300)
}

const EVENTS = {
  productCardSwatchClick: 'productCard:SwatchClick',
}

export const productCardSwatches = SAXX.Init.Component((node, ctx) => {
  const swatches = node.querySelectorAll('.variant--swatch')

  swatches.forEach((swatch) => {
    ctx.on(EVENTS.productCardSwatchClick, (_, details) => {
      if (swatch.getAttribute('data-card-id') !== details.id) return

      swatch.classList.toggle(
        'variant--swatch__active',
        swatch.href.toString() === details.url.toString(),
      )
    })

    swatch.addEventListener('click', (e) => {
      const parentCard = swatch.closest('.product-card--full__combined')

      if (!parentCard) return

      e.preventDefault()
      const url = new URL(swatch.href)
      url.searchParams.set('view', 'combined-listing-card')

      parentCard.classList.add('loading')

      fetch(url.toString())
        .then((res) => res.text())
        .then((response) => {
          const section = new DOMParser().parseFromString(response, 'text/html')

          parentCard
            .querySelector('.full-card--link')
            ?.replaceWith(section.querySelector('.full-card--link'))
          parentCard
            .querySelector('.full-card--image-carousel')
            ?.replaceWith(section.querySelector('.full-card--image-carousel'))
          parentCard
            .querySelector('.full-card--content-container')
            ?.replaceWith(
              section.querySelector('.full-card--content-container'),
            )
          parentCard
            .querySelector('.full-card--mobile-quick-shop-container')
            ?.replaceWith(
              section?.querySelector('.full-card--mobile-quick-shop-container'),
            )

          parentCard.className =
            section.querySelector('.product-card').className

          parentCard.setAttribute(
            'data-product-handle',
            section
              .querySelector('.product-card')
              .getAttribute('data-product-handle'),
          )

          SAXX.App.mount()

          url.searchParams.delete('view')
          ctx.emit(EVENTS.productCardSwatchClick, null, {
            url,
            id: parentCard.getAttribute('data-card-id'),
          })
        })
        .catch((error) => {
          console.error(error)
          window.location.href = swatch.href
        })
    })
  })
})

export const productCardAction = SAXX.Init.Component((node, ctx) => {
  node.addEventListener('change', async () => {
    const formData = new FormData(node)

    const variantInput = node.querySelector(
      `input[value="${formData.get('id')}"]`,
    )

    formData.append(
      'properties[_ORIGINAL_PRICE]',
      variantInput.getAttribute('data-original-price'),
    )
    if (variantInput.hasAttribute('data-final-sale')) {
      formData.append('properties[_ASRC]', 'Final Sale')
    }

    ctx.emit(THEME.drawerControlInteraction, null, {
      controlElement: 'slide-out-cart',
    })

    const response = await addItemById(formData)

    if (!response || response.status === 422) {
      return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
        cart: response,
      })
    }

    ctx.emit(CARTSTATES.UPDATED, null, {
      cart: response,
      addedLineItems: response.items,
    })

    if (node.hasAttribute('data-close-target')) {
      closeQuickShop(node.getAttribute('data-close-target'))
    }

    node
      .querySelectorAll('.quick-shop--input')
      .forEach((input) => (input.checked = false))
  })
})

export const productCardQuickShop = SAXX.Init.Component((node, ctx) => {
  node.addEventListener('click', (e) => {
    e.preventDefault()
    const templateTarget = document.querySelector(
      `#${node.getAttribute('data-quick-shop-target')}`,
    )
    const quickShopId = templateTarget.getAttribute('data-quick-shop-id')
    const quickShop = templateTarget.content.cloneNode(true)

    quickShop.querySelectorAll('[data-close-target]').forEach((node) => {
      node.addEventListener('click', () => {
        closeQuickShop(quickShopId)
      })
    })

    document.body.appendChild(quickShop)
    SAXX.App.mount()
    ctx.emit(THEME.drawerControlInteraction)
    setTimeout(() => {
      document.getElementById(quickShopId).setAttribute('aria-expanded', 'true')
    }, 50)
  })
})
